/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import nProgress from "nprogress";
import { getReplies } from "./ReportsAPI";
import { Modal } from "react-bootstrap";

function RepliesModal({ showReplies, setShowReplies }) {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const perPage = 10;

  // modal closes when showreplies is set to null
  const handleClose = () => {
    setShowReplies(null);
  };

  // react-bootstrap-table change handler
  const tableChangeHandler = (type, { page: newPage }) => {
    setPage(newPage);
  };

  const columns = [
    {
      dataField: "id",
      text: "ID",
    },
    {
      dataField: "dateTime",
      text: "Date/Time",
      formatter: (cell) =>
        new Date(`${cell.split(" ").join("T")}Z`).toLocaleString(),
    },
    {
      dataField: "message",
      text: "Reply",
    },
  ];

  // get new data when modal is shown and pagination changes
  useEffect(() => {
    if (showReplies !== null) {
      nProgress.start();
      getReplies({
        transactionId: showReplies?.id,
        offset: (page - 1) * perPage,
        limit: perPage,
      }).then((newData) => {
        setData(newData);
        nProgress.done();
      });
    }
  }, [showReplies, page, perPage]);

  return (
    <Modal
      show={showReplies !== null}
      onHide={handleClose}
      size={showReplies?.channel === "email" ? "lg" : undefined}
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="icon fa fa-comments" /> Message and replies
          <strong className="badge badge-default pull-right margin-right-20">
            {data?.total ?? 0} replies
          </strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Message</h4>
        <div dangerouslySetInnerHTML={{ __html: showReplies?.message }} />
        {data?.total > 0 && (
          <>
            <hr />
            <h4>Replies</h4>
            <BootstrapTable
              remote
              keyField="id"
              data={data?.rows ?? []}
              columns={columns}
              bordered={false}
              hover
              pagination={paginationFactory({
                page,
                sizePerPage: 10,
                totalSize: data?.total ?? 0,
                hidePageListOnlyOnePage: true,
                hideSizePerPage: true,
              })}
              onTableChange={tableChangeHandler}
            />
          </>
        )}
        <div className="text-center red-800">{data?.error ?? ""}</div>
      </Modal.Body>
    </Modal>
  );
}

export default RepliesModal;
